game = {};
gameData = {};
gameData.gameName = "8 Balls of Fire Blazing Bounty™";
gameData.gameVersionMajor = "1";
gameData.gameVersionMinor = "4";
gameData.gameVersionBugFix = "7";
gameData.gameReleaseDate = "30/04/26"; // update me upon release
gameData.goldenBetMultiplier = 1.5;
gameData.symbolWidth = 159;
gameData.symbolHeight = 151;
gameData.appertureSize = 173;
gameData.numReels = 6;
gameData.numRows = 3;

game.sideMenuOpen = false;

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

game.features = [];
game.currentFeature = 0;
game.maxFeatureIndex = 3;
game.featureAnimating = false;
game.featureAutoTimeline = undefined;

game.thunderAnim = undefined;
game.lightningFlash = undefined;
game.lightningFlashAnim = undefined;
game.filterLandscapeAnim = undefined;
game.filterPortraitAnim = undefined;

///////////////////////
// Developer options //
///////////////////////#

let devMode = false;
Reflex.developerModeData.checkUnusuedResources = devMode;
Reflex.developerModeData.highlightTranslatedText = devMode;
Reflex.developerModeData.showButtonHitAreas = devMode;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  let credit = creditTask.data.balance;
  if (
    gdk.serverParser._inReplayMode === true &&
    gdk.serverParser._endGame === true &&
    typeof gdk.serverParser.prepaidResultBalance === "number" &&
    gdk.serverParser.prepaidResultBalance !== 0
  ) {
    credit = gdk.serverParser.prepaidResultBalance;
  }
  gameData.creditMeter.set(credit);
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    " v" +
    gameData.gameVersionMajor +
    "." +
    +gameData.gameVersionMinor +
    "." +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;
  game.timeScale = 1;

  gameData.goldenBetMultiplier = 1.5;

  // Set initial state
  resourceManager.getController("inputOverlord").setState("enabled");

  gameData.musicManager = resourceManager.get("musicManager");

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer("gameContainer").visible = false;
  resourceManager.getContainer("DemoContainer").visible = false;
  resourceManager.getContainer("gameButtonContainer").visible = false;

  const bgContainer = resourceManager.getContainer("backgroundContainer");
  bgContainer.visible = true;

  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);
  gameData.goldenBetMultiplier = 1.5;
  systemData.gameContainer.mask = gameData.gameMask;
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;

  gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  gameData.winningsMeterTitle = resourceManager.get(
    "meterContainer:winnings:title"
  );

  messageBus.subscribe("common:BalanceEvent", game.onCreditChanged);
  messageBus.subscribe("game:modal", game.modal);
  messageBus.subscribe("game:sideMenuOpen", game.sideMenuOpenMsg);
  messageBus.subscribe("game:sideMenuClosed", game.sideMenuClosedMsg);
  Reflex.registerEventHandler("resize", game.onResize);
  Reflex.registerEventHandler("orientationChange", game.onOrientationChange);
  messageBus.subscribe("game:backFromReplay", game.backFromReplay);
  messageBus.subscribe("game:skipSplash", game.skipSplash);

  //document.addEventListener("keydown", game.onKeyDown);

  gameController.initialise(gameConfigTask);

  // Kick off the game
  game.onOrientationChange();
  game.onResize();
  gameController.start();
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }
};

game.onCloseTutorial = function () {};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on("mouseup", function () {});
  background.on("touchend", function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on("mouseup", function () {});
  portrait_background.on("touchend", function () {});
};

game.showCurrentFeature = function () {
  game.features.forEach((feature) => {
    feature.visible = false;
    feature.alpha = 0;
  });

  game.features[game.currentFeature].visible = true;
  game.features[game.currentFeature].alpha = 1;
};

game.createThunderAnim = function () {
  let thunder = resourceManager.get("baseGameBackground:vortex:thunder");
  thunder.visible = false;
  thunder.alpha = 0;

  const duration = 0.08;

  game.thunderAnim = gsap
    .timeline({ paused: true, repeat: 2 })
    .call(() => {
      thunder.visible = true;
    })
    .to(thunder, {
      duration,
      alpha: 1,
    })
    .to(thunder, {
      duration,
      alpha: 0,
      onComplete: () => {
        thunder.visible = false;
      },
    });
};

game.goToSplash = function () {
  if (!game.splashScreenDone) {
    game.splashScreenDone = true;
    resourceManager.getContainer("loadingbackgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = true;
    resourceManager.getContainer("helpPageScrollContainer").visible = true;

    gameData.helpPageScroll = resourceManager.get(
      "helpPageScrollContainer:helpPageScroll"
    );

    game.volcano = resourceManager.createObject(
      "spine",
      `Volcano`,
      `splashBg`,
      {
        name: "Volcano",
        x: 672,
        y: 460,
        defaultAnimation: "Volcano_Intensity_1",
        anchor: 0.5,
        scaleX: 0.5,
        scaleY: 0.5,
        skin: "Day",
      }
    );
    game.volcano.setSkin("Day");
    game.volcano.play("Volcano_Intensity_1", true, 0, undefined);
    game.volcano.visible = true;

    let background = resourceManager.get("splashBg");
    let portrait_background = resourceManager.get("splashBgPortrait");
    background.interactive = true;
    portrait_background.interactive = true;

    background.on("mouseup", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    background.on("touchend", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });

    portrait_background.on("mouseup", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    portrait_background.on("touchend", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });

    if (!gdk.getPlatformAllowsSplashScreen()) {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    }
  }
};

game.skipSplash = function () {
  let license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license === "default";
  }

  license = gameData.license.toUpperCase();

  if (license !== "BR") return;

  let background = resourceManager.get("splashBg");
  let portrait_background = resourceManager.get("splashBgPortrait");
  game.disableSplashBackgrounds(background, portrait_background);
  game.goToGame();
};

game.checkShouldShowPaytableAfterSplash = function () {
  let license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license === "default";
  }

  license = gameData.license.toUpperCase();

  if (license === "BR" && !gameController.gameRecovering) {
    return true;
  }
  return false;
};

game.changeStake = function (stake) {
  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
  gameController.onStakeChanged(stake);
};

game.recoverPots = function (stake) {
  console.log("🔵 POT RECOVERY: Overide pot values");
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");

  gameController.potsRecovered = true;

  if (gameData.miniJackpotAtGameStart) {
    miniPot.setText(
      gdk.formatCurrency(
        gameData.miniJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (gameData.minorJackpotAtGameStart) {
    minorPot.setText(
      gdk.formatCurrency(
        gameData.minorJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (gameData.majorJackpotAtGameStart) {
    majorPot.setText(
      gdk.formatCurrency(
        gameData.majorJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (gameData.ultraJackpotAtGameStart) {
    ultraPot.setText(
      gdk.formatCurrency(
        gameData.ultraJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (gameData.megaJackpotAtGameStart) {
    megaPot.setText(
      gdk.formatCurrency(
        gameData.megaJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }

  if (gameData.blazingMultiplierAtGameStart) {
    gameController.blazingMultiplierValue.setText(
      "X" + gameData.blazingMultiplierAtGameStart
    );

    if (
      gameController.currentBlazingMultiplier !==
      gameData.blazingMultiplierAtGameStart
    ) {
      gameController.currentBlazingMultiplier = parseFloat(
        gameData.blazingMultiplierAtGameStart
      );
      let animationName = "x" + gameController.currentBlazingMultiplier;
      animationName = animationName.replace(".", "_");
      //If the spine track holds the same animation as the current one, we don't want to play it again.
      if (
        gameController.thermometer.children[0].state.tracks[0].animation.name !=
        animationName
      ) {
        gameController.thermometer.play(animationName, true, 0, undefined);
      }
    }
  }
};

game.goToGame = function () {
  let license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license === "default";
  }

  license = gameData.license.toUpperCase();
  gameController.slotMachine.update(0);

  if (license !== "BR") {
    gdk.loadingClosed();
  }

  if (bowser.chrome && bowser.android) {
    var chromeVersion = Number(
      String(bowser.version).substring(0, String(bowser.version).indexOf("."))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  if (gameData.recoveryStake) {
    game.changeStake(gameData.recoveryStake);
    game.recoverPots(gameData.recoveryStake);
  }

  if (gameData.encoreEnabled) {
    var encoreButtonLB = resourceManager.get("goldenBetToggleButton");
    encoreButtonLB.setRecovery();
    encoreButtonLB.showButton();
  }
  game.slideShowActive = false;
  timerManager.stop(game.slideshowTimer);
  soundManager.stop("splash_screen");

  gameData.musicManager.setUpSounds();
  gameData.musicManager.setIdleMusic(true);

  resourceManager.getContainer("splashContainer").visible = false;
  resourceManager.getContainer("gameContainer").visible = true;
  resourceManager.getContainer("DemoContainer").visible = true;
  resourceManager.getContainer("gameButtonContainer").visible = true;
  resourceManager.getContainer("stakeSelectionContainer").visible = true;
  resourceManager.getContainer("backgroundContainer").visible = true;
  resourceManager.getContainer("PopupMaskContainer").visible = true;
  //resourceManager.getContainer("mobileMeterPanel").visible = true;
  resourceManager.get("baseGameBackground").visible = true;
  resourceManager.getContainer("featureUIContainer").visible = true;
  resourceManager.getContainer("popupContainer").visible = true;
  resourceManager.get("meterContainer").visible = true;

  game.onOrientationChange();

  gameController.volcano.play("Splash Transition", false, 0, () => {
    gameController.updateVolcanoLevel(
      gameController.currentPersistenceState.playerState.volcanoLevel,
      true
    );
  });

  game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.gameRecovering) {
    gameController.initNewGame();
  }
};

game.overrideButtons = function () {
  const autoplayController =
    resourceManager.getController("autoplayController");

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play("buttonPressed");
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play("buttonPressed");
    }
    baseCancel();
  };

  const spinButton = resourceManager.get("spinButton");
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return this.canEnableBase() && !game.sideMenuOpen;
  };

  const autoplayButton = resourceManager.get(
    "uiContainer:buttonContainer:autoplayButton"
  );
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const stakeButton = resourceManager.get("uiContainer:buttonContainer:stake");
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const volumeButton = resourceManager.get("volume");
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
};

game.modal = function (task) {
  if (task.reason === "autoplay") {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === "") {
    game.autoplayPopupOpen = false;
  }
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post("sounds:restorePreviouslyPlayingAudio", {
      reason: "back from replay",
    });
  }
};

// game.onKeyDown = function (event) {
//   if (event.key === "*") {
//     game.timeScale *= 2;
//   } else if (event.key === "/") {
//     game.timeScale /= 2;
//   } else if (event.key === "-") {
//     game.timeScale = 1;
//   } else if (event.key === "0") {
//     game.timeScale = 0;
//   } else if (event.key === "1") {
//     game.timeScale = 0.0625;
//   } else if (event.key === "2") {
//     game.timeScale = 0.125;
//   } else if (event.key === "3") {
//     game.timeScale = 0.25;
//   } else if (event.key === "4") {
//     game.timeScale = 0.5;
//   } else if (event.key === "5") {
//     game.timeScale = 1;
//   } else if (event.key === "6") {
//     game.timeScale = 2;
//   } else if (event.key === "7") {
//     game.timeScale = 4;
//   } else if (event.key === "8") {
//     game.timeScale = 8;
//   } else if (event.key === "9") {
//     game.timeScale = 16;
//   }

//   if (game.timeScale > 256) game.timeScale = 256;
//   if (game.timeScale < 0) game.timeScale = 0;

//   game.setSpeed(game.timeScale);
// };

// game.setSpeed = function (speed) {
//   if (Reflex.gamePaused || Reflex.platformPaused) {
//     soundManager.pauseAllSounds();
//   } else {
//     soundManager.resumeAllSounds();
//   }
//   soundManager.setTimeScale(speed);
//   gsap.globalTimeline.timeScale(speed);
//   Reflex.setGameSpeed(speed);
// };

// SPA - not used
// game.onAutoplayButtonPressed = function() {

//     // If autoplay is running, cancel
//     if (autoplayManager.isAutoplayEnabled()) {
//         if (gameController.state === "WAITING_FOR_AUTOPLAY") {
//             soundManager.play(gameData.sounds.autoplayCancel);
//         }
//         else {
//             // We are autoplaying, so wait for autoplay to complete before enabling buttons
//             gameData.autoplayButton.enableButton(false);
//         }

//         autoplayManager.stopAutoplay();
//         gameController.cancelAutoplay();

//         return;
//     }

//     // If we are in a waiting state, pop up the auto play interface
//     if (gameController.state === "WAITING_FOR_START") {

//         soundManager.play(gameData.sounds.autoplayPress);
//         autoplayManager.openDialog(game.onAutoplayDialogConfirmed, game.onAutoplayDialogCancelled, gameData.coinSizes[gameData.currentStakeIndex], 20);
//     }

// };
